// extracted by mini-css-extract-plugin
module.exports = {"filesWrap":"MessageItem_filesWrap__j88wx","row":"MessageItem_row__1K0IB","transparent":"MessageItem_transparent__jhNI1","filesWrapColumn":"MessageItem_filesWrapColumn__5mFu1"};